import { render, staticRenderFns } from "./UpAndSixDiscount.vue?vue&type=template&id=64822c8f&scoped=true"
import script from "./UpAndSixDiscount.vue?vue&type=script&lang=js"
export * from "./UpAndSixDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64822c8f",
  null
  
)

export default component.exports